import type { DynamicFormAnswer, DynamicFormAnswers, DynamicFormsApiService } from '@api_patient/dynamic_forms_api.service';
import { applicationSessionStorage } from '@application/application_storage_session';
import { FormGraphApiModel } from '@visiba/api-vcs-client-v2';
import { FormDataProvider } from './form_data_provider';

export class FormDataProviderLocal implements FormDataProvider {
	public id: Guid;
	public formId: number;
	private unitId: number;

	constructor(
		unitId: number,
		formId: number,
		id: Guid,
		private readonly formsApiService: DynamicFormsApiService,
	) {
		this.unitId = unitId;
		this.formId = formId;
		this.id = id;
		// Empty
	}

	public async getForm(): AsyncResult<FormGraphApiModel> {
		const result = await this.formsApiService.getById(this.unitId, this.formId);

		if (result.err) {
			return Err(result.err);
		}

		return Ok(result.ok.data);
	}

	public async getAnswers(): AsyncResult<DynamicFormAnswers> {
		const answers: DynamicFormAnswers = {
			completed: false,
			answers: [],
		};

		const sessionData = this.getDataFromStorage();
		if (sessionData) {
			const form = sessionData[this.formId];
			if (form) {
				answers.completed = form.completed;
				answers.answers = form.answers;
			}
		}

		return Ok(answers);
	}

	public async answer(answers: DynamicFormAnswer[]): AsyncResult {
		let data = applicationSessionStorage.get('dynamicForms');
		if (data == null) {
			data = {};
		}

		if (data[this.id] == null) {
			data[this.id] = {};
		}

		if (data[this.id][this.formId] == null) {
			data[this.id][this.formId] = {
				completed: false,
				answers: [],
			};
		}

		data[this.id][this.formId] = {
			completed: false,
			answers: [
				...data[this.id][this.formId].answers.filter(
					(oldAnswer) => !answers.find((answer) => answer.questionId == oldAnswer.questionId),
				),
				...answers,
			],
		};

		applicationSessionStorage.set('dynamicForms', data);

		return Ok();
	}

	public async setCompletion(): AsyncResult {
		const data = applicationSessionStorage.get('dynamicForms') ?? {};
		data[this.id][this.formId].completed = true;

		applicationSessionStorage.set('dynamicForms', data);

		return Ok();
	}

	private getDataFromStorage() {
		return applicationSessionStorage.get('dynamicForms')?.[this.id] ?? null;
	}
}
